import React from 'react';
export function Footer() {
  return <footer className="w-full bg-brand-purpleDark px-4 py-10 text-center" data-id="element-101">
      <div className="mx-auto max-w-2xl" data-id="element-102">
        <div className="flex items-center justify-center gap-1.5" data-id="element-103">
          <span className="font-display text-lg font-extrabold tracking-tight text-white" data-id="element-104">
            KARITO
          </span>
          <span className="font-display text-lg font-extrabold tracking-tight text-brand-pink" data-id="element-105">
            EDUCA
          </span>
        </div>
        <p className="mx-auto mt-3 max-w-md text-sm font-semibold text-white/60" data-id="element-106">
          Recursos inteligentes para docentes que quieren enseñar mejor y vivir
          mejor.
        </p>
        <p className="mt-6 text-xs font-semibold text-white/35" data-id="element-107">
          © {new Date().getFullYear()} Karito Educa. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}